import { XMarkIcon } from "@heroicons/react/24/solid";
import { integerName } from "../../../app/utils";
import { AlertLevel } from "../../../components/AlertMessage";
import ButtonWithConfirm from "../../../components/ButtonWithConfirm";
import { useRemoveUserFromSchoolMutation } from "../../schools/schoolsApiSlice";
import { UserSchoolViewModel } from "../usersApiSlice";

interface RemoveFromSchoolProps {
	selectedSchools: UserSchoolViewModel[];
	isLoading: boolean;
	name: string;
	userId: number;
	showDisenrollmentMessage: boolean;
	resetTable: () => void;
	setIsLoading: (loading: boolean) => void;
}

export default function RemoveUserFromSchool(props: RemoveFromSchoolProps) {
	const length = props.selectedSchools.length;

	const [removeFromSchool] = useRemoveUserFromSchoolMutation();

	async function handleRemove() {
		props.setIsLoading(true);

		const promises = props.selectedSchools.map(async (school) => {
			await removeFromSchool({
				schoolId: school.schoolID,
				userId: props.userId,
			})
				.unwrap()
				.catch((error) => {
					console.error(`Error removing user from school ${school.name}:`, error);
				});
		});

		await Promise.all(promises);
		props.resetTable();
	}

	return (
		<ButtonWithConfirm
			id="remove-from-schools-button"
			className="btn btn-neutral"
			disabled={length == 0 || props.isLoading}
			message={`Are you sure you want to remove ${props.name}? This action will remove the user from the ${length == 1 ? "selected school" : `${integerName(length)} selected schools`}${props.showDisenrollmentMessage ? ` and all active courses associated with any active selected school${length == 1 ? "" : "s"}.` : "."} `}
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={handleRemove}>
			<XMarkIcon className="h-4 inline mr-2" />
			Remove
		</ButtonWithConfirm>
	);
}
